module.exports = __webpack_public_path__ + "img/cart.1211eec5.svg";